import type { APPLICANT_ATTRIBUTION } from 'cpool-constants';
import { createId } from 'cpool-utils';

export const getBaseCreditDefaultValues = (attribution: APPLICANT_ATTRIBUTION) => ({
    gehoertZuAntragsteller: attribution,
    glaeubiger: null,
    id: createId(),
    source: 'MANUALLY' as const,
});
